import React from 'react';
import { Label, Segment, Header, Grid } from 'semantic-ui-react';
import Moment from 'moment';

import './style.css';

const Banner = (props) => {
    return (
        <Segment
            className="banner-cover"
            textAlign="center"
            style={{padding: 80}}>
            <Grid.Column width={6}>
                <Grid columns={1}>
                    <Grid.Column width={16}>
                        <Header className="banner-text" size="large" style={{color: "#fff", textTransform: 'capitalize'}}>
                            { (props.user) ? `Hello ${props.user.name}!` : 'Hello!'}
                            <br />
                            What would you want to do today?
                            <Header.Subheader style={{color: "#fff"}}>
                                <b style={{paddingRight: 10, fontWeight: 200, fontSize: 20}}>
                                    { Moment(new Date()).format('dddd DD MMM YYYY')}, Singapore
                                </b>
                            </Header.Subheader>
                        </Header>
                    </Grid.Column>
                </Grid>
            </Grid.Column>

        </Segment>
    );
}

// const Banner = (props) => {
//     return (
//         <Segment
//             className="banner-cover"
//             textAlign="center"
//             style={{padding: 50}}
//         >
//             <Header size="huge" style={{color: "#333", textTransform: 'capitalize'}}>
//                 { (props.user) ? `Hello ${props.user.name}!` : 'Hello Elliot!'}
//                 <br />
//                 What would you want to do today?
//             </Header>
//             <Header.Subheader style={{color: "#333"}}>
//                 <b style={{paddingRight: 10, fontWeight: 200, fontSize: 20}}>
//                     { Moment(new Date()).format('dddd Do MMMM YYYY')}, Singapore
//                 </b>
//             </Header.Subheader>
//         </Segment>
//     );
// }

export default Banner;

/*
<Header.Subheader style={{color: "#FFF"}}>
    <b style={{paddingRight: 10, fontWeight: 200}}>
        { Moment(new Date()).format('dddd Do MMMM YYYY hh:MM:SS a')}, Singapore
    </b>
    <Label>
        27.c Cloudy
    </Label>
</Header.Subheader>
*/
